import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-p2-stat-source-edit',
  templateUrl: './p2-stat-source-edit.component.html',
  styleUrls: ['./p2-stat-source-edit.component.css']
})
export class P2StatSourceEditComponent implements OnInit {
    p2StatSourceKeyno;

    public edit?: Edit;

    public selectListTailorAccesses: Item[] = [];

    public saving = false;

    public statSourceHeadingButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'translateedit', gotoParms: () => this.edit!.word_id_heading ?? '' }
    ];

    public statSourceDescriptionButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'translateedit', gotoParms: () => this.edit!.word_id_description ?? '' }
    ];

    public tailorAccessButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-bars', goto: 'tailoraccesses' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2StatSourceKeyno = this.stateService.getStateParams()['p2_statsource_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2StatSourceKeyno) {
            this.edit = (await this.datatask.Post(808, { p2_statsource_keyno: this.p2StatSourceKeyno }))[0];
        }
    }

    private async loadTailorAccesses(): Promise<void> {
        this.selectListTailorAccesses = await this.datatask.Post(2094);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(809, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadTailorAccesses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_statsource_keyno: string;
    table_name: string;
    word_id_heading: string;
    word_id_description: string;
    statsource_heading: string;
    statsource_description: string;
    tailoraccess_keyno: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2StatSourceEdit', {
//        templateUrl: 'views/components/views/p2StatSourceEdit/p2StatSourceEdit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'p2StatSourceEditService', 'tailorAccessesService', function ($stateParams, stateService, p2StatSourceEditService, tailorAccessesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2StatSourceKeyno = $stateParams.p2_statsource_keyno;

//            vm.model = {
//                statSourceHeadingButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('translateedit', { item_id: vm.model.edit.word_id_heading }) }
//                ],
//                statSourceDescriptionButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('translateedit', { item_id: vm.model.edit.word_id_description }) }
//                ],
//                tailorAccessButtons1: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('tailoraccesses') }
//                ],
//                tailorAccessButtons2: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.tailoraccess_keyno = '0' },
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('tailoraccesses') }
//                ],
//                edit: {},
//                selectListTailorAccesses: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadEdit = function () {
//                p2StatSourceEditService.getEdit({ p2_statsource_keyno: p2StatSourceKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            }

//            let loadTailorAccesses = function () {
//                tailorAccessesService.listTailorAccesses().then(function (list) {
//                    angular.copy(list, vm.model.selectListTailorAccesses);
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                p2StatSourceEditService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadTailorAccesses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
